<style>
.outer {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.innerLogin {
  margin-left: auto;
  margin-right: auto;
  width: 1098px;
}

.innerLoginWhitelabel {
  margin-left: auto;
  margin-right: auto;
  width: 700px;
}

.borderGradient {
  border-top: 5px solid #0179f3 !important;
}
</style>
<template>
  <div id="user">
    <div
      v-if="!$store.state.user.username && !$vuetify.breakpoint.mobile"
      class="outer"
    >
      <div class="middle">
        <div
          v-bind:class="{
            innerLoginWhitelabel: $store.state.site.whitelabel,
            innerLogin: !$store.state.site.whitelabel
          }"
        >
          <v-row>
            <v-col>
              <v-card class="rounded-xl" elevation="7" height="530" width="700">
                <v-container>
                  <v-form ref="form" class="pa-4 pt-6">
                    <p class="text-center text-h4">
                      Login to
                      <span
                        v-bind:class="{
                          gradient: !$store.state.site.whitelabel,
                          troploGradient: $store.state.site.whitelabel
                        }"
                        >{{ $store.state.site.name }}</span
                      >
                    </p>
                    <v-text-field
                      class="rounded-xl"
                      v-model="email"
                      label="Username or Email Address"
                      type="email"
                      :outlined="!$store.state.site.whitelabel"
                      @keyup.enter="doLogin"
                    ></v-text-field>
                    <v-text-field
                      class="rounded-xl"
                      v-model="password"
                      color="blue accent-7"
                      label="Password"
                      type="password"
                      :outlined="!$store.state.site.whitelabel"
                    ></v-text-field>
                    <v-text-field
                      class="rounded-xl"
                      v-model="totpCode"
                      color="blue accent-7"
                      label="2FA Code (if enabled)"
                      placeholder="123456"
                      type="number"
                      :outlined="!$store.state.site.whitelabel"
                    >
                    </v-text-field>
                    <p
                      style="float: right; color: #2196f3; cursor: pointer"
                      @click="doPasswordReset()"
                    >
                      Reset your Password
                    </p>
                    <v-checkbox
                      v-model="tempLogin"
                      label="Logout on refresh"
                    ></v-checkbox>
                    <br />
                    <v-divider class="mt-5"></v-divider>
                    <v-card-actions>
                      <v-btn
                        class="rounded-xl"
                        v-if="$store.state.site.registrations"
                        text
                        @click="$router.push('/register')"
                      >
                        Register instead
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="rounded-xl"
                        v-if="!$store.state.site.whitelabel"
                        color="#7289da"
                        href="https://discord.com/api/oauth2/authorize?client_id=879994391203315722&redirect_uri=https%3A%2F%2Fjays.host%2FdiscordAuthorize%2Flogin&response_type=code&scope=identify%20guilds%20guilds.join"
                        text
                      >
                        Login with Discord
                      </v-btn>
                      <v-btn
                        class="rounded-xl"
                        v-if="$store.state.site.whitelabel"
                        :href="
                          'https://sso.flowinity.com/auth/realms/master/protocol/openid-connect/auth?client_id=' +
                          $store.state.site.flowinityId +
                          '&redirect_uri=' +
                          $store.state.site.hostnameWithProtocol +
                          '%2FflowinityAuthorize%2Flogin&response_type=code'
                        "
                        color="primary lighten-2"
                        text
                      >
                        Login with Flowinity
                      </v-btn>
                      <v-btn
                        class="rounded-xl"
                        :loading="loading"
                        color="primary"
                        text
                        @click="doLogin()"
                      >
                        Login
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-container>
              </v-card>
            </v-col>
            <v-col v-if="!$store.state.site.whitelabel">
              <v-card
                align="center"
                class="rounded-xl"
                elevation="7"
                height="530"
                width="370"
              >
                <div class="pa-4 pt-6">
                  <p class="text-center text-h4" style="font-weight: 500">
                    Statistics
                  </p>
                  <p class="text-center text-h6">
                    Users -
                    <span
                      v-bind:class="{
                        gradient: !$store.state.site.whitelabel,
                        troploGradient: $store.state.site.whitelabel
                      }"
                      >{{ $store.state.site.stats.users }}</span
                    >
                  </p>
                  <p class="text-center text-h6">
                    Uploads -
                    <span
                      v-bind:class="{
                        gradient: !$store.state.site.whitelabel,
                        troploGradient: $store.state.site.whitelabel
                      }"
                      >{{ $store.state.site.stats.uploads }}</span
                    >
                  </p>
                  <p class="text-center text-h6">
                    Domains -
                    <span
                      v-bind:class="{
                        gradient: !$store.state.site.whitelabel,
                        troploGradient: $store.state.site.whitelabel
                      }"
                      >{{ $store.state.site.stats.domains }}</span
                    >
                  </p>
                  <p class="text-center text-h4" style="font-weight: 500">
                    Credits
                  </p>
                  <p class="text-center text-h6">
                    Owner -
                    <span
                      v-bind:class="{
                        gradient: !$store.state.site.whitelabel,
                        troploGradient: $store.state.site.whitelabel
                      }"
                      >Jay</span
                    >
                  </p>
                  <p class="text-center text-h6">
                    Developer -
                    <a
                      href="https://troplo.com"
                      style="font-weight: 600; text-decoration: none"
                      ><span style="color: #1badfc">Troplo</span></a
                    >
                  </p>
                  <p class="text-center text-h6">
                    Developer -
                    <a
                      href="https://bytedefined.com"
                      style="font-weight: 600; text-decoration: none"
                      ><span style="color: #ff7b39">Bytedefined</span></a
                    >
                  </p>
                  <p class="text-center text-h6">
                    Administrator -
                    <a
                      href="https://cpn.ac"
                      style="font-weight: 600; text-decoration: none"
                      ><span style="color: #ff6663">Prism</span></a
                    >
                  </p>
                  <p class="text-center text-h6">
                    Moderator -
                    <a
                      href="https://dopp.in"
                      style="font-weight: 600; text-decoration: none"
                      ><span style="color: #fdfd97">Bhop</span></a
                    >
                  </p>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <v-container
      v-if="!$store.state.user.username && $vuetify.breakpoint.mobile"
    >
      <v-row>
        <v-col>
          <v-card class="rounded-xl" elevation="7">
            <v-container>
              <v-form ref="form" class="pa-4 pt-6 text-center">
                <p class="text-center text-h4">
                  Login to
                  <span
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                    >{{ $store.state.site.name }}</span
                  >
                </p>
                <v-btn
                  class="rounded-xl"
                  v-if="!$store.state.site.whitelabel"
                  color="#7289da"
                  href="https://discord.com/api/oauth2/authorize?client_id=879994391203315722&redirect_uri=https%3A%2F%2Fjays.host%2FdiscordAuthorize%2Flogin&response_type=code&scope=identify%20guilds%20guilds.join"
                  text
                >
                  Login with Discord
                </v-btn>
                <v-btn
                  class="rounded-xl"
                  v-if="$store.state.site.whitelabel"
                  :href="
                    'https://sso.flowinity.com/auth/realms/master/protocol/openid-connect/auth?client_id=' +
                    $store.state.site.flowinityId +
                    '&redirect_uri=' +
                    $store.state.site.hostnameWithProtocol +
                    '%2FflowinityAuthorize%2Flink&response_type=code'
                  "
                  color="primary"
                  text
                >
                  Login with Flowinity
                </v-btn>
                <v-text-field
                  class="rounded-xl"
                  v-model="email"
                  color="blue accent-7"
                  label="Username or Email Address"
                  type="email"
                  :outlined="!$store.state.site.whitelabel"
                ></v-text-field>
                <v-text-field
                  class="rounded-xl"
                  v-model="password"
                  color="blue accent-7"
                  label="Password"
                  type="password"
                  :outlined="!$store.state.site.whitelabel"
                ></v-text-field>
                <v-text-field
                  class="rounded-xl"
                  v-model="totpCode"
                  color="blue accent-7"
                  label="2FA Code (if enabled)"
                  placeholder="123456"
                  type="number"
                  :outlined="!$store.state.site.whitelabel"
                >
                </v-text-field>
                <p
                  style="float: right; color: #2196f3; cursor: pointer"
                  @click="doPasswordReset()"
                >
                  Reset your Password
                </p>
                <v-checkbox
                  v-model="tempLogin"
                  label="Logout on refresh"
                ></v-checkbox>
                <v-divider class="mt-2"></v-divider>
                <v-card-actions>
                  <v-btn
                    class="rounded-xl"
                    text
                    @click="$router.push('/register')"
                  >
                    Register instead
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="rounded-xl"
                    :loading="loading"
                    color="primary"
                    text
                    @click="doLogin()"
                  >
                    Login
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-container>
          </v-card>
        </v-col>
        <v-col v-if="!$store.state.site.whitelabel">
          <v-card align="center" class="rounded-xl" elevation="7">
            <div class="pa-4 pt-6">
              <p class="text-center text-h4" style="font-weight: 500">
                Statistics
              </p>
              <p class="text-center text-h6">
                Users -
                <span
                  v-bind:class="{
                    gradient: !$store.state.site.whitelabel,
                    troploGradient: $store.state.site.whitelabel
                  }"
                  >{{ $store.state.site.stats.users }}</span
                >
              </p>
              <p class="text-center text-h6">
                Uploads -
                <span
                  v-bind:class="{
                    gradient: !$store.state.site.whitelabel,
                    troploGradient: $store.state.site.whitelabel
                  }"
                  >{{ $store.state.site.stats.uploads }}</span
                >
              </p>
              <p class="text-center text-h6">
                Domains -
                <span
                  v-bind:class="{
                    gradient: !$store.state.site.whitelabel,
                    troploGradient: $store.state.site.whitelabel
                  }"
                  >{{ $store.state.site.stats.domains }}</span
                >
              </p>
              <p class="text-center text-h4" style="font-weight: 500">
                Credits
              </p>
              <p class="text-center text-h6">
                Owner -
                <span
                  v-bind:class="{
                    gradient: !$store.state.site.whitelabel,
                    troploGradient: $store.state.site.whitelabel
                  }"
                  >Jay</span
                >
              </p>
              <p class="text-center text-h6">
                Developer -
                <a
                  href="https://troplo.com"
                  style="font-weight: 600; text-decoration: none"
                  ><span style="color: #1badfc">Troplo</span></a
                >
              </p>
              <p class="text-center text-h6">
                Developer -
                <a
                  href="https://bytedefined.com"
                  style="font-weight: 600; text-decoration: none"
                  ><span style="color: #ff7b39">Bytedefined</span></a
                >
              </p>
              <p class="text-center text-h6">
                Administrator -
                <a
                  href="https://cpn.ac"
                  style="font-weight: 600; text-decoration: none"
                  ><span style="color: #ff6663">Prism</span></a
                >
              </p>
              <p class="text-center text-h6">
                Moderator -
                <a
                  href="https://dopp.in"
                  style="font-weight: 600; text-decoration: none"
                  ><span style="color: #fdfd97">Bhop</span></a
                >
              </p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="$store.state.user.username">
      <v-row>
        <v-col>
          <v-card v-if="!loading" class="rounded-xl ma-2" elevation="7">
            <v-container class="text-center">
              <v-avatar
                v-if="$store.state.user.avatar"
                :src="'/i/' + $store.state.user.avatar"
                align="center"
                class="text-center"
                height="90"
                width="90"
              >
                <img
                  v-if="$store.state.user.avatar"
                  :src="'/i/' + $store.state.user.avatar"
                />
              </v-avatar>
              <v-avatar
                v-if="!$store.state.user.avatar"
                :src="
                  '/api/v1/userutils/identicon/' + $store.state.user.username
                "
                align="center"
                class="text-center justify-center"
                justify="center"
                size="90"
              >
                <img
                  v-if="!$store.state.user.avatar"
                  :src="
                    '/api/v1/userutils/identicon/' + $store.state.user.username
                  "
                />
              </v-avatar>
              <br />
              <span class="text-h4"> {{ $store.state.user.username }} </span
              ><br />
              <v-chip
                v-if="
                  $store.state.user.plan.internalName.indexOf('CSTM_TIER_') >= 0
                "
                :color="$store.state.user.plan.color"
                class="ma-2"
                text-color="white"
              >
                <v-icon> {{ $store.state.user.plan.icon }}</v-icon
                >&nbsp;
                {{ $store.state.user.plan.name }}
              </v-chip>
              <v-chip
                v-if="$store.state.user.admin"
                class="ma-2"
                color="red"
                text-color="white"
              >
                <v-icon> mdi-gavel</v-icon>&nbsp;Administrator
              </v-chip>
              <v-chip
                v-if="$store.state.user.moderator"
                class="ma-2"
                color="green"
                text-color="white"
              >
                <v-icon> mdi-shield</v-icon>&nbsp;Moderator
              </v-chip>
              <v-chip
                v-if="
                  $store.state.user.plan.internalName !== 'FREE' &&
                  $store.state.user.plan.internalName.indexOf('CSTM_TIER_')
                "
                :color="$store.state.user.plan.color"
                class="ma-2"
                text-color="white"
              >
                <v-icon> {{ $store.state.user.plan.icon }}</v-icon
                >&nbsp;
                {{ $store.state.user.plan.name }}
              </v-chip>
              <v-chip
                v-if="$store.state.user.beta"
                class="ma-2"
                color="deep-purple"
                text-color="white"
              >
                β Beta
              </v-chip>
            </v-container>
          </v-card>
          <br />
          <v-card class="rounded-xl ma-2" elevation="7">
            <v-container class="text-center">
              <p
                class="text-h4"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                More Information
              </p>
              <v-card-text
                v-if="$store.state.user.domain && !$store.state.user.subdomain"
              >
                <span style="font-weight: 500">Description</span> -
                {{ $store.state.user.description }}<br />
                <span style="font-weight: 500">Registration Date</span> -
                {{
                  moment($store.state.user.createdAt).format(
                    "Do of MMMM YYYY, h:mm A"
                  )
                }}<br />
                <span style="font-weight: 500">Applied Domain</span> -
                {{ $store.state.user.domain.domain }}<br />
                <span style="font-weight: 500">Invited by</span> -
                {{ $store.state.user.invite.user.username }}<br />
                <span style="font-weight: 500">User ID</span> -
                {{ $store.state.user.id }}<br />
              </v-card-text>
              <v-card-text v-if="$store.state.user.subdomain">
                <span style="font-weight: 500">Description</span> -
                {{ $store.state.user.description }}<br />
                <span style="font-weight: 500">Registration Date</span> -
                {{
                  moment($store.state.user.createdAt).format(
                    "Do of MMMM YYYY, h:mm A"
                  )
                }}<br />
                <span style="font-weight: 500">Applied Domain</span> -
                {{ $store.state.user.domain.domain }}<br />
                <span style="font-weight: 500">Invited by</span> -
                {{ $store.state.user.invite.user.username }}<br />
                <span style="font-weight: 500">User ID</span> -
                {{ $store.state.user.id }}<br />
              </v-card-text>
            </v-container>
          </v-card>
          <br />
          <v-card class="rounded-xl ma-2" elevation="7">
            <v-container>
              <p
                class="text-h4 text-center"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Announcements
              </p>
              <v-card
                v-for="announcement in $store.state.site.announcements"
                :key="announcement.id"
                :type="announcement.type"
                class="rounded-xl mx-2 ma-3"
                dense
                elevation="6"
                text
              >
                <v-container class="text-center align-center justify-center">
                  <div>
                    <v-avatar
                      v-if="announcement.user.avatar"
                      :src="'/i/' + announcement.user.avatar"
                      align="center"
                      class="text-center justify-center"
                      justify="center"
                      size="40"
                    >
                      <img
                        v-if="announcement.user.avatar"
                        :src="'/i/' + announcement.user.avatar"
                      />
                    </v-avatar>
                    <v-avatar
                      v-if="!announcement.user.avatar"
                      :src="
                        '/api/v1/userutils/identicon/' +
                        announcement.user.username
                      "
                      align="center"
                      class="text-center justify-center"
                      justify="center"
                      size="40"
                    >
                      <img
                        v-if="!announcement.user.avatar"
                        :src="
                          '/api/v1/userutils/identicon/' +
                          announcement.user.username
                        "
                      />
                    </v-avatar>
                    <p class="text-h5">
                      {{ announcement.user.username }}
                    </p>
                    <div class="text-block" style="white-space: pre-line">
                      {{ announcement.content }}
                    </div>
                    <small>{{
                      moment(announcement.createdAt).format(
                        "Do of MMMM YYYY, h:mm A"
                      )
                    }}</small>
                  </div>
                </v-container>
              </v-card>
            </v-container>
          </v-card>
          <v-card v-if="loading" class="rounded-xl" elevation="7">
            <v-container class="text-center">
              <p class="text-lg-h4">Loading...</p>
            </v-container>
          </v-card>
        </v-col>
        <v-col v-if="!loading">
          <v-row no-gutters>
            <v-col md="3" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    Site Domains
                  </p>
                  <b class="text-h4">{{ $store.state.site.stats.domains }}</b>
                </v-container>
              </v-card>
            </v-col>
            <v-col md="3" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    Site Users
                  </p>
                  <b class="text-h4">{{ $store.state.site.stats.users }}</b>
                </v-container>
              </v-card>
            </v-col>
            <v-col md="3" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    Site Uploads
                  </p>
                  <b class="text-h4">{{ $store.state.site.stats.uploads }}</b>
                </v-container>
              </v-card>
            </v-col>
            <v-col md="3" sm="5" xs="12">
              <v-card class="rounded-xl mx-2 ma-2" elevation="7">
                <v-container class="text-center">
                  <p
                    class="text-h5"
                    v-bind:class="{
                      gradient: !$store.state.site.whitelabel,
                      troploGradient: $store.state.site.whitelabel
                    }"
                  >
                    Site Usage
                  </p>
                  <b class="text-h4">{{
                    fileSize($store.state.site.stats.usage.result)
                  }}</b>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
          <br />
          <v-card class="rounded-xl ma-2" elevation="7">
            <v-container class="text-center">
              <p
                class="text-h4"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Statistics
              </p>
              <chart></chart>
            </v-container>
          </v-card>
          <br />
          <v-card
            v-if="
              $store.state.user.discordId && $store.state.user.discordUserCache
            "
            class="rounded-xl ma-2"
            elevation="7"
          >
            <v-container class="text-center">
              <p
                class="text-h4"
                v-bind:class="{
                  gradient: !$store.state.site.whitelabel,
                  troploGradient: $store.state.site.whitelabel
                }"
              >
                Discord
              </p>
              <!--              <v-avatar class="text-center" align="center" height="90" width="90" v-if="$store.state.user.discordUserCache.avatar">
                              <v-img :src="'https://cdn.discordapp.com/avatars/' + $store.state.user.discordUserCache.id + '/' + $store.state.user.discordUserCache.avatar + '.png'"></v-img>
                            </v-avatar>-->
              <p class="text-h6">
                {{ $store.state.user.discordUserCache.username }}#{{
                  $store.state.user.discordUserCache.discriminator
                }}
              </p>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import moment from "moment"
import Chart from "../components/Chart"

export default {
  name: "Home",
  components: {
    Chart
  },
  data() {
    return {
      testData: [
        { label: "Red", value: 300 },
        { label: "Blue", value: 50 },
        { label: "Yellow", value: 100 }
      ],
      loading: false,
      stats: {
        uploads: 0
      },
      totpCode: "",
      email: "",
      password: "",
      inviteKey: "",
      tempLogin: false,
      rules: {
        email: (v) => !!(v || "").match(/@/) || "Please enter a valid email",
        length: (len) => (v) =>
          (v || "").length >= len ||
          `Invalid character length, required ${len}`,
        password: (v) =>
          !!(v || "").match(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/
          ) ||
          "Password must contain an upper case letter, a numeric character, and a special character",
        required: (v) => !!v || "This field is required"
      }
    }
  },
  methods: {
    calculateType(type) {
      if (type === "error") {
        return "Important"
      } else if (type === "info") {
        return "Announcement"
      }
    },
    fileSize(fileSize) {
      let i = -1
      let byteUnits = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      do {
        fileSize = fileSize / 1024
        i++
      } while (fileSize > 1024)

      return Math.max(fileSize, 0.1).toFixed(1) + byteUnits[i]
    },
    doPasswordReset() {
      this.loading = true
      this.axios
        .post("/api/v1/auth/passwordReset/send", {
          email: this.email
        })
        .then(() => {
          this.loading = false
          this.$router.push("/passwordReset/sent")
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    moment(params) {
      return moment(params)
    },
    copyAPIKey() {
      navigator.clipboard.writeText(this.$store.state.user.apiKey)
    },
    getUserData() {
      this.loading = false
      this.axios.get("/api/v1/userutils/stats").then((res) => {
        this.loading = false
        this.stats = res.data
      })
    },
    doLogin() {
      this.loading = true
      this.axios
        .post("/api/v1/auth/login", {
          email: this.email,
          password: this.password,
          code: this.totpCode
        })
        .then((res) => {
          this.loading = false
          this.$store.commit("login", res.data)
          if (!this.tempLogin) {
            localStorage.setItem("token", res.data.token)
          }
          Object.assign(this.axios.defaults, {
            headers: { Authorization: this.$store.state.user.token }
          })
          this.axios
            .get("/api/v1/userutils/info")
            .then((res) => {
              this.$store.commit("login", res.data)
              this.$router.push("/dashboard")
              this.getUserData()
              this.$toast("You have been logged in.", {
                timeout: 3000,
                type: "success"
              })
            })
            .catch((e) => {
              AjaxErrorHandler(this.$store)(e)
            })
        })
        .catch((e) => {
          if (e.response.data.errors[0].name === "remoteSSOProvider") {
            window.location.href =
              "https://sso.flowinity.com/auth/realms/master/protocol/openid-connect/auth?client_id=" +
              this.$store.state.site.flowinityId +
              "&redirect_uri=" +
              this.$store.state.site.hostnameWithProtocol +
              "%2FflowinityAuthorize%2Flogin&response_type=code"
          }
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getUserData()
  }
}
</script>

<style scoped></style>

